<template>
  <div>
    <div class="columns is-multiline dashboard-div" v-if="visible">
      <div class="column is-12" v-if="value">
        <div class="columns is-multiline">
          <!-- 문의/답변 관리 -->
          <div class="column is-full" v-if="cs">
            <inner-view>
              <div class="box">
                <div class="panel-header">
                  <div class="panel-title">오늘 CS 현황</div>
                </div>

                <div class="panel-content">
                  <div :style="gridCs()">
                    <template v-for="csKey in Object.keys(cs)">
                      <div v-if="cs[csKey]" :key="`cs-${csKey}`"
                           class="lp-content-box-1"
                           @click="$router.push(getPath(cs[csKey].url))">
                        <div class="lp-content-box-title-1">{{ cs[csKey].label }}</div>
                        <div class="lp-count">{{ cs[csKey].count|currency }}</div>
                        <template v-if="cs[csKey].reply_stand !== undefined">
                          <div class="lp-reply-wrapper" style="margin:12px 0 2px 0">답변대기
                            <span class="reply-count primary">{{ cs[csKey].reply_stand }}</span></div>
                          <div class="lp-reply-wrapper">답변완료
                            <span class="reply-count">{{ cs[csKey].reply_success }}</span></div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </inner-view>
          </div>
        </div>

        <!-- 주요 현황 -->
        <template v-if="chartData && chartData.chart">
          <div class="columns is-multiline">
            <div class="column is-full">
              <div class="box">
                <div class="panel-header">
                  <div class="panel-title">오늘 사용자 참여 전환 Funnel 현황</div>
                </div>
                <div class="panel-content">
                  <div :style="grid(chartData.chart.dataset.length)">
                    <div v-for="(data, d_idx) in chartData.chart.dataset" :key="`data-${d_idx}`">
                      <div class="chart-label">
                        <div :style="chartBg(data)"></div>
                        <div>{{ data.label }}</div>
                      </div>
                      <div :style="chartColor(data)" class="chart-count">{{ data.data.slice(-1)[0]|currencyNum }}</div>
                    </div>
                  </div>
                  <!-- 차트 -->
                  <div class="lp-chart-box">
                    <chart :data="chartData.chart" :height="300" v-if="chartData.chart"></chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <panel-today-popular></panel-today-popular>
      </div>
    </div>

  </div>
</template>

<script>
  import chart from '../../../LineChart.js'
  import InnerView from "../../layout/InnerView";
  import PanelTodayPopular from "./components/PanelTodayPopular";
  export default {
    layout: 'Main',
    name: 'dashboard',
    components: {
      PanelTodayPopular,
      InnerView,
      chart
    },
    created() {
      this.getData();
      this.getTodayCs();
      this.getChartData();
    },
    data() {
      return {
        tabPartnerId: 0,
        value: {},
        // 차트
        chartData: {},
        visible: false,
        selectedPanel: undefined,
        cs: undefined
      }
    },
    methods: {
      getUrl(name) {
        return 'partner/'+this.$store.getters.partner.space_partner+ '/space/' + name;
      },
      chartBg(item) {
        return `width:10px;height:10px;background-color:${item.backgroundColor}`;
      },
      chartColor(item) {
        return `color:${item.backgroundColor}`;
      },
      getTodayCs() {
        this.$axios.get(this.getUrl('dashboard/cs')).then(res=> {
          if(res.status===200) {
            this.cs = res.data;
          }
        })
      },
      getData() {
        this.$axios.get(this.getUrl('dashboard')).then(res => {
          if (res.status === 200) {
            this.value = res.data;
            if (!this.selectedPanel)
              this.selectedPanel = this.value.pack_panels[0];
            else {
              let sel = this.value.pack_panels.filter(item => {
                return item.package === this.selectedPanel.package
              });
              if (sel.length > 0) {
                this.selectedPanel = sel[0];
              } else {
                this.selectedPanel = this.value.pack_panels[0];
              }
            }
            this.visible = true;
          }
        })
      },
      getChartData() {
        let url = 'dashboard/chart';
        this.chartData = {};
        this.$axios.get(this.getUrl(url)).then(res => {
          if (res.status === 200) {
            this.chartData = res.data;
          }
        })
      },
      grid(num) {
        return {
          display: 'grid',
          gridTemplateColumns: `repeat(${num}, 1fr)`
        }
      },
      gridCs() {
        return this.grid(
          ['product_call', 'product_inquiry', 'product_review', 'personal_inquiry'].filter(i => this.cs[i]).length
        );
      }
    }
  }
</script>



<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-content-box
  .lp-more
  .lp-notice-content
    cursor pointer

  .lp-chart-box
    background-color white
    padding-top 24px
    padding-bottom 10px

  .lp-dashboard-title1
    padding 16px
    background-color white
    color $main
    font-weight 300
    font-size 16px
    border-bottom 1px solid $gray2

  .lp-dashboard-title
    padding 16px
    background-color white
    color #989898
    font-size 16px

  .lp-dashboard-content
    padding 16px
    padding-top 0
    display flex
    background-color white

  .lp-content-box
    width 46%
    border 1px solid #eee
    margin 0 2% 8px 2%

  /*width 50%*/
  /*border 1px solid #eee*/
  /*margin 0 4px*/

  .lp-content-box:hover
    background-color #eee

  .lp-light-black
  .lp-light-grey
    font-size 12px

  .lp-light-black
    color #333333

  .lp-light-grey
    color #989898

  .lp-btn-setting
    cursor pointer
    margin-left 12px

  .lp-content-box-title
    text-align center
    padding-top 16px
    font-size 12px

  .lp-content-box-data
    padding 16px
    text-align center
    color $primary
    font-size 26px
    font-weight bold

  .lp-content-box-1
    padding 16px 24px
    border 1px solid #eee
    border-left 0
    cursor pointer
    user-select none

  .lp-content-box-1:first-child
    border-left 1px solid #eee
    border-top-left-radius 6px
    border-bottom-left-radius 6px
  .lp-content-box-1:last-child
    border-top-right-radius 6px
    border-bottom-right-radius 6px

  .lp-content-box-1:hover
    background-color #eee

  .lp-content-box-title-1
    font-size 14px
    color #787878
    margin-bottom 8px

  .lp-content-box-data-1
    font-size 18px
    font-weight 600
  .primary
    color $primary

  .chart-label
    display flex
    align-items center
    gap 0 4px
    font-size 13px
    color #4A4A4A
  .chart-count
    font-size 14px

  .lp-dashboard-table
    width 100%
    background-color white

  .lp-dashboard-table th
  .lp-dashboard-table td
    text-align center !important
    font-size 12px

  .lp-dashboard-table th
    font-weight unset

  .lp-dashboard-table tr
    height 40px
    line-height 40px

  .lp-service-charge
    border-radius 24px
    padding 4px
    font-size 12px
    background-color #eee
    text-align center
    color #333

  .lp-more
    font-size 12px
    line-height 12px
    color $sub3
    font-weight 400

  .lp-notice-content
    background-color white
    padding 16px

  .lp-site-analytics
    background-color rgb(255, 120, 77)
    width 124px
    height 32px
    text-align center
    line-height 32px
    font-size 12px
    color white
    border-radius 3px

  .lp-background:hover
    background-color #eee

  /*.dashboard-div
    margin-bottom 80px !important

  @media(max-width:768px)
    .dashboard-div
      margin-bottom 578px !important*/


  .tab-item
    padding 4px 12px
    margin-right 8px

  .tab-item-selected
    background-color #ff5722
    color white
    border-radius 30px

  .select-partner
    background white
    border 1px solid #ddd
    padding 4px 12px
    border-radius 30px

    select
      border 0

  .panel-tab
    background-color white
    display flex
    flex-wrap wrap
    padding 12px

  .panel-tab-item
    padding 4px 12px
    font-size 14px
    color #777

  .panel-tab-item-selected
    background-color #ff5722
    border-radius 30px
    color white

  .panel-tab-1
    display flex
    background-color #f5f5f5

  .panel-tab-item-1
    flex 1
    padding 4px 12px
    font-size 14px
    color #363636
    font-weight 400
    display flex
    align-items center
    justify-content center
    text-align center
    gap 4px

  .panel-tab-item-1-selected
    background-color white
    font-weight 500
    padding 10px
    display flex
    align-items center
    justify-items center

  .lp-panel-box
    border 1px solid #eee
    border-right 0
    cursor pointer
    padding 16px 24px

  .lp-panel-box:first-child
    border-top-left-radius 6px
    border-bottom-left-radius 6px
  .lp-panel-box:last-child
    border-right 1px solid #eee
    border-top-right-radius 6px
    border-bottom-right-radius 6px

  .lp-panel-box:hover
    background-color #f5f5f5

  .panel-daily-title
    font-size 14px
    margin-bottom 4px

  .panel-daily-price
    font-size 26px

  .lp-panel-content
    padding 4px
    width 20%

  @media (max-width: 768px)
    .panel-daily-title
      font-size 12px

    .panel-daily-price
      font-size 16px

    .lp-panel-content
      width 50%

  .card-top-product
    display flex
    padding 6px 20px 6px 0
    border-bottom 1px solid #dddddd
    align-items center
    font-size 12px
    color #4a4a4a

  .card-top-product-partner-name
    color #9b9b9b

  .card-top-product:hover
    background-color #f5f5f5

  .lp-reply-wrapper
    font-size 13px
    .reply-count
      margin-left 4px
      font-weight 700

  .lp-count
    font-size 18px
    line-height 18px
    font-weight 600

  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .panel-title
    color $main
    font-size 21px
    font-weight 300

  .panel-content
    padding 20px

  .grid-daily
    display grid
    grid-template-columns repeat(3, 1fr)
    gap 8px

    .grid-item-daily
      padding 0 24px
      height 85px
      display flex
      align-items center
      border-radius 6px
    .order
      background-color #FFEAD2
      color #7A060B
    .pay
      background-color #E6DFFF
      color #1C127A
    .refund
      background-color #F5F5F5
      color #363636
    .grid-daily-title
      font-size 14px
      font-weight 500
      line-height 22px
    .grid-daily-price
      font-size 20px
      font-weight 500
      line-height 20px
      margin-top 8px
</style>
